import { Check } from "@phosphor-icons/react";
import { REPURPOSE_CATEGORIES, ALL_TARGETS } from "@/lib/repurposeConstants";

export function FormatSelector({ chainMode, activeCategory, setActiveCategory, targetIdx, setTargetIdx, chainSelected, toggleChainTarget }) {
  const getTargetIndex = (target) => ALL_TARGETS.findIndex((t) => t.type === target.type && t.platform === target.platform);

  return (
    <div>
      <div className="flex flex-nowrap overflow-x-auto gap-1.5 mb-3 pb-1 md:flex-wrap md:overflow-visible md:pb-0 no-scrollbar">
        {REPURPOSE_CATEGORIES.map((cat) => (
          <button key={cat.label} onClick={() => setActiveCategory(cat.label)} data-testid={`repurpose-cat-${cat.label.toLowerCase().replace(/\s+/g, '-')}`}
            className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
              activeCategory === cat.label ? "bg-[#FF4400] text-white" : "bg-[var(--bg-base)] text-[var(--text-muted)] hover:text-[var(--text-primary)] border border-[var(--border)]"
            }`}>{cat.label} ({cat.targets.length})</button>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {REPURPOSE_CATEGORIES.find((c) => c.label === activeCategory)?.targets.map((target) => {
          const idx = getTargetIndex(target);
          const isChainSel = chainMode && chainSelected.includes(idx);
          const isSingleSel = !chainMode && targetIdx === idx;
          return (
            <button key={`${target.type}-${target.platform}`} onClick={() => chainMode ? toggleChainTarget(idx) : setTargetIdx(idx)} data-testid={`repurpose-target-${idx}`}
              className={`px-3 py-2.5 rounded-md text-sm text-left border transition-all relative ${
                isChainSel || isSingleSel ? "bg-[var(--accent-subtle)] border-[#FF4400] text-[#FF4400]" : "bg-[var(--bg-base)] border-[var(--border-strong)] text-[var(--text-secondary)] hover:border-[var(--text-muted)]"
              }`}>
              {chainMode && (
                <span className={`absolute top-1.5 right-1.5 w-4 h-4 rounded-full border-2 flex items-center justify-center text-[8px] font-bold transition-all ${
                  isChainSel ? "bg-[#FF4400] border-[#FF4400] text-white" : "border-[var(--border-strong)]"
                }`}>{isChainSel && <Check size={8} weight="bold" />}</span>
              )}
              <div className="font-medium text-xs">{target.type}</div>
              <div className="text-[10px] opacity-60 mt-0.5">{target.platform}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function SubOptions({ showSlide, showThread, showEmail, slideCount, setSlideCount, threadCount, setThreadCount, emailCount, setEmailCount }) {
  return (
    <>
      {showSlide && (
        <div>
          <label className="block font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[var(--text-muted)] mb-2">Slides</label>
          <div className="flex gap-2">
            {[3, 5, 7, 10].map((n) => (
              <button key={n} onClick={() => setSlideCount(n)} data-testid={`slide-count-${n}`}
                className={`px-4 py-2 rounded-md text-sm border transition-all ${slideCount === n ? "bg-[var(--accent-subtle)] border-[#FF4400] text-[#FF4400]" : "bg-[var(--bg-base)] border-[var(--border-strong)] text-[var(--text-secondary)]"}`}>{n}</button>
            ))}
          </div>
        </div>
      )}
      {showThread && (
        <div>
          <label className="block font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[var(--text-muted)] mb-2">Thread Posts</label>
          <div className="flex gap-2">
            {[3, 5, 7, 10].map((n) => (
              <button key={n} onClick={() => setThreadCount(n)} data-testid={`thread-count-${n}`}
                className={`px-4 py-2 rounded-md text-sm border transition-all ${threadCount === n ? "bg-[var(--accent-subtle)] border-[#FF4400] text-[#FF4400]" : "bg-[var(--bg-base)] border-[var(--border-strong)] text-[var(--text-secondary)]"}`}>{n}</button>
            ))}
          </div>
        </div>
      )}
      {showEmail && (
        <div>
          <label className="block font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[var(--text-muted)] mb-2">Emails</label>
          <div className="flex gap-2">
            {[3, 5, 7].map((n) => (
              <button key={n} onClick={() => setEmailCount(n)} data-testid={`email-count-${n}`}
                className={`px-4 py-2 rounded-md text-sm border transition-all ${emailCount === n ? "bg-[var(--accent-subtle)] border-[#FF4400] text-[#FF4400]" : "bg-[var(--bg-base)] border-[var(--border-strong)] text-[var(--text-secondary)]"}`}>{n}</button>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
